/* unplugin-vue-components disabled */import { render } from "./goals.vue?vue&type=template&id=144cb516&scoped=true"
import script from "./goals.vue?vue&type=script&lang=js"
export * from "./goals.vue?vue&type=script&lang=js"

import "./goals.vue?vue&type=style&index=0&id=144cb516&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144cb516"]])

export default __exports__